<div class="t-widget--noPadding">
  <header class="l-flex-column l-align-top summary-box-header">
    <h2 class="t-widgetTitle">
      {{ "translate.dashboard.invoicesSummaryTitle" | translate }}
    </h2>
    <hr />
  </header>
  <div class="summary-row">
    <p class="lbl colored">
      {{ "translate.dashboard.totalDebt" | translate }}
    </p>
    <p class="value">
      <span class="l-num">{{ data.totalBalDept | currency: "ILS" }}</span>
    </p>
  </div>
</div>
